export const CostCategories = {
  EXPENSE_ADMINISTRATIVE: 'expense_administrative',
  EXPENSE_COUNTER_PARTIES: 'expense_counter_parties',
  EXPENSE_ENERGY: 'expense_energy',
  EXPENSE_EQUIPMENT: 'expense_equipment',
  EXPENSE_FIELD: 'expense_field',
  EXPENSE_FUEL: 'expense_fuel',
  EXPENSE_INSURANCE: 'expense_insurance',
  EXPENSE_LICENSE: 'expense_license',
  EXPENSE_MAINTENANCE: 'expense_maintenance',
  EXPENSE_MANPOWER: 'expense_manpower',
  EXPENSE_MARKETING: 'expense_marketing',
  EXPENSE_OTHER: 'expense_other',
  EXPENSE_PACKAGING: 'expense_packaging',
  EXPENSE_RENT: 'expense_rent',
  // EXPENSE_RENTALS : "expense_rentals",
  EXPENSE_SERVICE: 'expense_service',
  EXPENSE_TAXES: 'expense_taxes',
  EXPENSE_WATER: 'expense_water',
};
